/**
 * French locale configuration for react-multi-date-picker
 * Shared across all calendar components to avoid duplication
 */
export const gregorian_fr = {
  name: "gregorian_fr",
  months: [
    ["Janvier", "Janv."],
    ["Février", "Févr."],
    ["Mars", "Mars"],
    ["Avril", "Avr."],
    ["Mai", "Mai"],
    ["Juin", "Juin"],
    ["Juillet", "Juil."],
    ["Août", "Août"],
    ["Septembre", "Sept."],
    ["Octobre", "Oct."],
    ["Novembre", "Nov."],
    ["Décembre", "Déc."]
  ],
  weekDays: [
    ["Samedi", "S"],
    ["Dimanche", "D"],
    ["Lundi", "L"],
    ["Mardi", "M"],
    ["Mercredi", "M"],
    ["Jeudi", "J"],
    ["Vendredi", "V"]
  ],
  digits: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
  meridiems: [
    ["AM", "am"],
    ["PM", "pm"]
  ]
};
